export const add = msg => ({ type: 'ADD_MESSAGE', payload: msg });

export const remove = key => ({ type: 'DELETE_MESSAGE', payload: key });